var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMultiDayIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68779 13L9.95212 13C11.558 13 12.8597 11.7688 12.8597 10.25L12.8597 5.75C12.8597 4.23122 11.558 3 9.95212 3L5.19419 3C3.58835 3 2.28657 4.23122 2.28657 5.75L2.28657 6L3.87254 6L3.87254 5.75C3.87254 5.05964 4.46427 4.5 5.19419 4.5L9.95212 4.5C10.682 4.5 11.2738 5.05964 11.2738 5.75L11.2738 10.25C11.2738 10.9404 10.682 11.5 9.95212 11.5L9.68779 11.5L9.68779 13Z",
    fill: "#5E5E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8598 10L13.1241 10C14.73 10 16.0317 8.76878 16.0317 7.25L16.0317 2.75C16.0317 1.23122 14.73 -1.13806e-07 13.1241 -2.54193e-07L8.36619 -6.70144e-07C6.76035 -8.1053e-07 5.45856 1.23122 5.45856 2.75L5.45856 3L7.04454 3L7.04454 2.75C7.04454 2.05964 7.63626 1.5 8.36619 1.5L13.1241 1.5C13.854 1.5 14.4458 2.05964 14.4458 2.75L14.4458 7.25C14.4458 7.94036 13.854 8.5 13.1241 8.5L12.8598 8.5L12.8598 10Z",
    fill: "#5E5E66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.75C0 7.23122 1.30179 6 2.90762 6H7.66555C9.27139 6 10.5732 7.23122 10.5732 8.75V13.25C10.5732 14.7688 9.27139 16 7.66555 16H2.90762C1.30179 16 0 14.7688 0 13.25V8.75Z",
    fill: "#5E5E66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiDayIcon);
export default __webpack_public_path__ + "static/media/multi-day-icon.3cc497d2.svg";
export { ForwardRef as ReactComponent };